import graphql from "babel-plugin-relay/macro";
import { useAtomValue } from "jotai";
import { useFragment } from "react-relay";

import { CurrentBookingWizardStepAtom } from "../../atoms/stores";
import { RequestWizardStepContainerNode$key } from "./__generated__/RequestWizardStepContainerNode.graphql";
import { AddPlayersPrivateStep } from "./steps/AddPlayersPrivateStep/AddPlayersPrivateStep";
import { AddPlayersPrivateStepClientProfile$key } from "./steps/AddPlayersPrivateStep/__generated__/AddPlayersPrivateStepClientProfile.graphql";
import { AddPlayersStep } from "./steps/AddPlayersStep/AddPlayersStep";
import { AddPlayersStepClientProfile$key } from "./steps/AddPlayersStep/__generated__/AddPlayersStepClientProfile.graphql";
import { RequestBookingDetailsStep } from "./steps/BookingDetailsStep/RequestBookingDetailsStep";
import { PreviousBookingsStep } from "./steps/PreviousBookingsStep/PreviousBookingsStep";
import { PreviousBookingsStepClientProfile$key } from "./steps/PreviousBookingsStep/__generated__/PreviousBookingsStepClientProfile.graphql";

type Props = {
  nodeRef: RequestWizardStepContainerNode$key | null;
  addPlayersRef: AddPlayersStepClientProfile$key | null;
  addPlayersPrivateRef: AddPlayersPrivateStepClientProfile$key | null;
  previousBookingsRef: PreviousBookingsStepClientProfile$key | null;
  onClose: () => void;
};

export const RequestWizardStepContainer = ({
  nodeRef,
  addPlayersRef,
  previousBookingsRef,
  addPlayersPrivateRef,
  onClose,
}: Props) => {
  const node = useFragment(
    RequestWizardStepContainerNodeFragmentString,
    nodeRef
  );
  const currentBookingWizardStep = useAtomValue(CurrentBookingWizardStepAtom);
  switch (currentBookingWizardStep) {
    case "BookingDetails":
      return <RequestBookingDetailsStep nodeRef={node ?? null} />;
    case "AddPlayers":
      return (
        <AddPlayersStep
          clientProfileRef={addPlayersRef}
          nodeRef={node ?? null}
        />
      );
    case "AddPlayersPrivate":
      return (
        <AddPlayersPrivateStep
          nodeRef={node ?? null}
          clientProfileRef={addPlayersPrivateRef}
        />
      );
    case "PreviousBookings":
      return (
        <PreviousBookingsStep
          previousBookingsRef={previousBookingsRef}
          previousBookingsTimeSlotRef={node ?? null}
          onClose={onClose}
        />
      );
    default:
      return null;
  }
};

export const RequestWizardStepContainerNodeFragmentString = graphql`
  fragment RequestWizardStepContainerNode on Node {
    ...RequestBookingDetailsStepNode
    ...AddPlayersStepNode
    ...AddPlayersPrivateStepNode
    ...PreviousBookingsStep_TimeSlot
  }
`;
